import { CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import type { UploadMetersResponse } from "@/api/districts";
import { Button } from "@/components/ui/button";

interface ImportMetersResultProps {
	response: UploadMetersResponse;
	onClose: () => void;
}

export function ImportMetersResult({
	response,
	onClose,
}: ImportMetersResultProps) {
	const { t } = useTranslation();
	const skipped = response.skipped ?? [];

	return (
		<div className="flex min-h-0 flex-1 flex-col gap-3 px-4 pb-4">
			<div className="flex items-start gap-2 rounded-md border border-primary/30 bg-primary/5 px-3 py-2 text-sm">
				<CheckCircle
					aria-hidden="true"
					className="mt-0.5 size-4 shrink-0 text-primary"
				/>
				<span>{response.detail}</span>
			</div>

			{skipped.length > 0 && (
				<>
					<div className="flex items-center gap-2 text-sm">
						<WarningCircle
							aria-hidden="true"
							className="size-4 text-amber-600"
						/>
						<span className="font-medium">
							{t("meterImport.skippedTitle", { count: skipped.length })}
						</span>
					</div>
					<div className="min-h-0 flex-1 overflow-auto rounded-md border">
						<table className="w-full text-sm">
							<thead className="sticky top-0 z-10 bg-muted/50">
								<tr className="border-b text-left">
									<th className="w-20 px-3 py-2 font-medium">
										{t("meterImport.skippedRow")}
									</th>
									<th className="px-3 py-2 font-medium">
										{t("meterImport.skippedReason")}
									</th>
								</tr>
							</thead>
							<tbody>
								{skipped.map((s) => (
									<tr
										key={`${s.row}-${s.reason}`}
										className="border-b last:border-b-0"
									>
										<td className="px-3 py-2 tabular-nums">{s.row}</td>
										<td className="px-3 py-2 text-muted-foreground">
											{s.reason}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</>
			)}

			<div className="flex justify-end">
				<Button onClick={onClose}>{t("meterImport.close")}</Button>
			</div>
		</div>
	);
}
